import { useQuery } from '@tanstack/react-query'
import { createContext, useContext, useEffect } from 'react'
import { http } from '@/lib/api/client'
import type { Dashboard, Resource } from '@/lib/api/types'

/** The dashboard's counts, shared by the menu's badges and the Briefing (refreshed every minute). */
export function useDashboard() {
  return useQuery({
    queryKey: ['dashboard'],
    queryFn: async () => (await http.get<Resource<Dashboard>>('/dashboard')).data,
    refetchInterval: 60_000,
  })
}

/* A detail page names itself in the location bar ("Customers › Bayside Agency"). */
export const CrumbContext = createContext<(name: string | null) => void>(() => {})

export function useCrumb(name: string | null | undefined) {
  const set = useContext(CrumbContext)
  useEffect(() => {
    set(name ?? null)
    return () => set(null)
  }, [name, set])
}

/* The palette opens from the sidebar, the location bar, ⌘K or "/". */
export const PaletteContext = createContext<() => void>(() => {})
export const useOpenPalette = () => useContext(PaletteContext)
